import {
    SET_SELECTED_CHALLENGE,
    SET_SELECTED_CHALLENGE_ID,
    SET_SELECTED_SEGMENT,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_SUCCEEDED,
    TOP_TAGS_FAILED,
    CHANGE_TEAM_MODE,
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    SEGMENTS_LIST_REQUESTED,
    SEGMENTS_LIST_SUCCEEDED,
    SEGMENTS_LIST_FAILED,
    SEGMENT_TAGS_REQUESTED,
    SEGMENT_TAGS_SUCCEEDED,
    SEGMENT_TAGS_FAILED,
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    SPECIFIC_CHALLENGE_REQUESTED,
    SPECIFIC_CHALLENGE_SUCCEEDED,
    SPECIFIC_CHALLENGE_FAILED,
    CONNECTED_CHALLENGE_REQUESTED,
    CONNECTED_CHALLENGE_SUCCEEDED,
    CONNECTED_CHALLENGE_FAILED,
    CHALLENGE_CODES_REQUESTED,
    CHALLENGE_CODES_SUCCEEDED,
    CHALLENGE_CODES_FAILED,
    SET_PARENT_CHALLENGE,
    CHALLENGE_NOTIFICATIONS_REQUESTED,
    CHALLENGE_NOTIFICATIONS_SUCCEEDED,
    CHALLENGE_NOTIFICATIONS_FAILED,
    ADD_CHALLENGE_NOTIFICATION_REQUESTED,
    ADD_CHALLENGE_NOTIFICATION_SUCCEEDED,
    ADD_CHALLENGE_NOTIFICATION_FAILED,
    CHALLENGE_NOTIFICATION_RESET,
    ADD_CHALLENGE_CODE_REQUESTED,
    ADD_CHALLENGE_CODE_SUCCEEDED,
    ADD_CHALLENGE_CODE_FAILED,
    UPDATE_CHALLENGE_CODE_REQUESTED,
    UPDATE_CHALLENGE_CODE_SUCCEEDED,
    UPDATE_CHALLENGE_CODE_FAILED,
    CLEAR_CHALLENGE_CODE_ERROR,
} from './constants';

export function setSelectedChallengeId(challengeId) {
    return {
        type: SET_SELECTED_CHALLENGE_ID,
        challengeId,
    };
}
export function clearChallengeUpdateError() {
    return {
        type: CLEAR_CHALLENGE_CODE_ERROR,
    };
}

export function setSelectedChallenge(challenge) {
    return {
        type: SET_SELECTED_CHALLENGE,
        challenge,
    };
}

export function setSelectedSegment(segmentId) {
    return {
        type: SET_SELECTED_SEGMENT,
        segmentId,
    };
}

export function setSelectedCode(codeId) {
    return {
        type: CHANGE_TEAM_MODE,
        codeId,
    };
}

export function topContributorsRequested(date, customDate) {
    return {
        type: TOP_CONTRIBUTORS_REQUESTED,
        date,
        customDate,
    };
}

export function topContributorsSucceeded(topContributors) {
    return {
        type: TOP_CONTRIBUTORS_SUCCEEDED,
        topContributors,
    };
}

export function topContributorsFailed(error) {
    return {
        type: TOP_CONTRIBUTORS_FAILED,
        error,
    };
}

export function topTagsRequested(taxonomy) {
    return {
        type: TOP_TAGS_REQUESTED,
        taxonomy,
    };
}

export function topTagsSucceeded(topTags) {
    return {
        type: TOP_TAGS_SUCCEEDED,
        topTags,
    };
}

export function topTagsFailed(error) {
    return {
        type: TOP_TAGS_FAILED,
        error,
    };
}

export function segmentsListRequested(segmentsLimit) {
    return {
        type: SEGMENTS_LIST_REQUESTED,
        segmentsLimit,
    };
}

export function segmentsListSucceeded(segments) {
    return {
        type: SEGMENTS_LIST_SUCCEEDED,
        segments,
    };
}

export function segmentsListFailed(error) {
    return {
        type: SEGMENTS_LIST_FAILED,
        error,
    };
}

export function segmentTagsRequested(segmentTaxonomy) {
    return {
        type: SEGMENT_TAGS_REQUESTED,
        segmentTaxonomy,
    };
}

export function segmentTagsSucceeded(segmentTags) {
    return {
        type: SEGMENT_TAGS_SUCCEEDED,
        segmentTags,
    };
}

export function segmentTagsFailed(error) {
    return {
        type: SEGMENT_TAGS_FAILED,
        error,
    };
}

export function impactFilterRequested(selectedFilter, zoom, dimensions) {
    return {
        type: IMPACT_FILTER_REQUESTED,
        selectedFilter,
        zoom,
        dimensions,
    };
}

export function impactFilterSucceeded(impactLitters) {
    return {
        type: IMPACT_FILTER_SUCCEEDED,
        impactLitters,
    };
}

export function impactFilterFailed(error) {
    return {
        type: IMPACT_FILTER_FAILED,
        error,
    };
}
export function challengeRequested(challengeId) {
    return {
        type: SPECIFIC_CHALLENGE_REQUESTED,
        challengeId,
    };
}

export function challengeSucceeded(challenge) {
    return {
        type: SPECIFIC_CHALLENGE_SUCCEEDED,
        challenge,
    };
}

export function challenegeFailed(error) {
    return {
        type: SPECIFIC_CHALLENGE_FAILED,
        error,
    };
}

export function connectedChallengeRequested() {
    return {
        type: CONNECTED_CHALLENGE_REQUESTED,
    };
}

export function connectedChallengeSucceeded(challenges) {
    return {
        type: CONNECTED_CHALLENGE_SUCCEEDED,
        challenges,
    };
}

export function connectedChallenegeFailed(error) {
    return {
        type: CONNECTED_CHALLENGE_FAILED,
        error,
    };
}

export function setParentChallenge(challenge) {
    return {
        type: SET_PARENT_CHALLENGE,
        parentChallenge: challenge,
    };
}

export function challengeCodesRequested() {
    return {
        type: CHALLENGE_CODES_REQUESTED,
    };
}

export function challengeCodesSucceeded(codes) {
    return {
        type: CHALLENGE_CODES_SUCCEEDED,
        codes,
    };
}

export function challengeCodesFailed(error) {
    return {
        type: CHALLENGE_CODES_FAILED,
        error,
    };
}

export function challengeNotificationsRequested() {
    return {
        type: CHALLENGE_NOTIFICATIONS_REQUESTED,
    };
}

export function challengeNotificationsSucceeded(notifications) {
    return {
        type: CHALLENGE_NOTIFICATIONS_SUCCEEDED,
        notifications,
    };
}

export function challengeNotificationsFailed(error) {
    return {
        type: CHALLENGE_NOTIFICATIONS_FAILED,
        error,
    };
}

export function addChallengeNotificationRequested({ title, message }) {
    return {
        type: ADD_CHALLENGE_NOTIFICATION_REQUESTED,
        title,
        message,
    };
}

export function addChallengeNotificationSucceeded(notification) {
    return {
        type: ADD_CHALLENGE_NOTIFICATION_SUCCEEDED,
        notification,
    };
}

export function addChallengeNotificationFailed(error) {
    return {
        type: ADD_CHALLENGE_NOTIFICATION_FAILED,
        error,
    };
}

export function addChallengeCodeRequested({ code }) {
    return {
        type: ADD_CHALLENGE_CODE_REQUESTED,
        code,
    };
}

export function addChallengeCodeSucceeded(code) {
    return {
        type: ADD_CHALLENGE_CODE_SUCCEEDED,
        code,
    };
}

export function addChallengeCodeFailed(error) {
    return {
        type: ADD_CHALLENGE_CODE_FAILED,
        error,
    };
}

export function updateChallengeCodeRequested({ payload }) {
    return {
        type: UPDATE_CHALLENGE_CODE_REQUESTED,
        payload,
    };
}

export function updateChallengeCodeSucceeded() {
    return {
        type: UPDATE_CHALLENGE_CODE_SUCCEEDED,
    };
}

export function updateChallengeCodeFailed(error) {
    return {
        type: UPDATE_CHALLENGE_CODE_FAILED,
        error,
    };
}

export function notificationsReset() {
    return {
        type: CHALLENGE_NOTIFICATION_RESET,
    };
}
